<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      class="notification_position z-notification shadow-card fixed w-[calc(100%-24px)] rounded border border-solid border-blue-400 bg-white tablet:max-w-[400px]"
      :class="isMobile ? 'animation_fade-in-up' : 'animation_fade-in-right'"
    >
      <slot />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
  interface IProps {
    isOpen: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    isOpen: false,
  });

  const { isMobile } = useScreen();
</script>

<style lang="scss" scoped>
  @keyframes fadeInRight {
    from {
      transform: translate3d(100%, 0, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInUp {
    from {
      transform: translate3d(0, 100%, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  .animation_fade-in-right {
    animation-name: fadeInRight;
    animation-duration: 1s;
  }

  .animation_fade-in-up {
    animation-name: fadeInUp;
    animation-duration: 1s;
  }

  .notification_position {
    @apply bottom-3 left-3 tablet:bottom-auto tablet:left-auto tablet:right-5 tablet:top-[calc(theme(spacing.header-height)+1rem)];
  }
</style>
